import { takeLatest, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  GET_EVENTS_REQUEST,
  GetEventsRequestAction,
  SEND_EVENT_REQUEST,
  SendEventRequestAction,
} from './events.types';
import {
  getEventsSuccess,
  getEventsFailure,
  sendEventSuccess,
  sendEventFailure,
} from './events.action';
import * as eventsService from '../../services/eventsService/eventsService';

function* getEventsWorker(action: GetEventsRequestAction): SagaIterator {
  try {
    const events = yield call(eventsService.getEvents, action.payload);
    yield put(getEventsSuccess(Array.isArray(events) ? events : []));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch events';
    yield put(getEventsFailure(errorMessage));
  }
}

function* sendEventWorker(action: SendEventRequestAction): SagaIterator {
  try {
    yield call(eventsService.sendEvent, action.payload);
    yield put(sendEventSuccess());
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to send event';
    yield put(sendEventFailure(errorMessage));
  }
}

export function* eventsSaga(): SagaIterator {
  yield takeLatest(GET_EVENTS_REQUEST, getEventsWorker);
  yield takeLatest(SEND_EVENT_REQUEST, sendEventWorker);
}
